import Checkers from "../../../../../../helpers/class/Checkers";
import { useT } from '../../../../../../helpers/i18n';
import * as React from "react";

interface Props {
    details: any
}

const LegalLicenseViewPort = ( props: Props) => {
  const t = useT();

    const { details } = props;

    const propertyLegalLicense = details.hasOwnProperty('property_legal_license') ? details.property_legal_license : null

    return (
        <>
            {
                Checkers.isValidString(propertyLegalLicense) ?
                    <div className="row w-100 m-0 mb-5">
                        <div className="col-12">
                            <span key={'property-legal-license'}
                                  className="btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active">
                                <i className={`fa-solid fa-file-certificate m-r-10`}></i>
                                {t('property.registrationNumber', { number: propertyLegalLicense })}
                          </span>
                            {/*  <p># Sea view</span><span*/}
                            {/*    className="btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active"># Luxury</span><span*/}
                            {/*    className="btn btn-default btn-cons btn-rounded btn-notification-style m-b-10 active"># Beachfront</span>*/}
                            {/*</p>*/}
                        </div>
                    </div>
                    :
                    <></>
            }
        </>
    )
}

export default LegalLicenseViewPort